import validate from "/app/node_modules/.pnpm/nuxt@3.16.0_@types+node@24.10.1_tsx@4.20.6_typescript@5.9.3_vite@5.4.21/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.0_@types+node@24.10.1_tsx@4.20.6_typescript@5.9.3_vite@5.4.21/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}